export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6998.dd38dc96.jpg";